__turbopack_context__.v({
  "cityRow": "AddressInput-module__Dqmh9q__cityRow",
  "dropdown": "AddressInput-module__Dqmh9q__dropdown",
  "field": "AddressInput-module__Dqmh9q__field",
  "item": "AddressInput-module__Dqmh9q__item",
  "itemAddress": "AddressInput-module__Dqmh9q__itemAddress",
  "itemMeta": "AddressInput-module__Dqmh9q__itemMeta",
  "postalField": "AddressInput-module__Dqmh9q__postalField",
  "wrapper": "AddressInput-module__Dqmh9q__wrapper",
});
